/* eslint-disable no-prototype-builtins */
import Axios from "axios";

function storeDeepData(data)
{
    // made a deep copy of my initial object to make it immutable by vue's weird reactivity system
    const myData = JSON.parse(JSON.stringify(data));
    return myData;
}

var myData;

function sortDifference(initialObject, updatedObject)
{
    var sortedProperties = {};

    for ( var key in initialObject)
    {
        if ( initialObject.hasOwnProperty(key) && updatedObject.hasOwnProperty(key) ) 
        {
            if (initialObject[key] !== updatedObject[key])
            {
                sortedProperties[key] = updatedObject[key];
            }
        }
    }

    return sortedProperties;
}

function commonUpdateRequest(endpoint, requestBody, dynamicID) {
    if(dynamicID)
    {
        return Axios.post(`${endpoint}/${dynamicID}`, requestBody, { withCredentials: false} );
    }
    else
    {
        return Axios.post(endpoint, requestBody, { withCredentials: false} );
    }
}

export { storeDeepData, myData, sortDifference , commonUpdateRequest };